export const buildManualConnectionPayload = (config, connection, applicationId) => ({
  name: config.name,
  setupMode: connection?.setupMode || "manual",
  phoneNumberId: config.phoneNumberId,
  wabaId: config.wabaId,
  metaApplicationId: applicationId ? Number(applicationId) : null,
  ...(config.accessToken ? { accessToken: config.accessToken } : {}),
  ...(config.verifyToken ? { verifyToken: config.verifyToken } : {}),
  queueId: Number(config.queueId),
  outboundQueueIds: config.outboundQueueIds,
  defaultUserId: config.defaultUserId ? Number(config.defaultUserId) : null,
  isDefault: Boolean(config.isDefault),
});

export const hasManualProviderChanges = (payload, connection) => Boolean(connection?.id) && [
  [payload.phoneNumberId, connection.phoneNumberId],
  [payload.wabaId, connection.wabaId],
  [payload.metaApplicationId, connection.metaApplicationId],
  ...(payload.accessToken ? [[payload.accessToken, connection.accessToken]] : []),
  ...(payload.verifyToken ? [[payload.verifyToken, connection.verifyToken]] : []),
].some(([next, current]) => String(next || "").trim() !== String(current || "").trim());

export const hasUsableNewVerifyToken = (value, editing) =>
  (!String(value || "").trim() && editing) || String(value || "").trim().length >= 16;
